import service from '../utils/request'
// 查询列表
export const query = params => { return service.post(`/api/base_monthcard_car/query`, params) };
// 创建
export const create = params => { return service.post(`/api/base_monthcard_car/webcreate`, params) };
// 修改
export const edit = params => { return service.put(`/api/base_monthcard_car/edit`, params) };
// 续费
export const renew = params => { return service.put(`/api/base_monthcard_car/renew`, params) };
// 删除
export const deleted = params => { return service.delete(`/api/base_monthcard_car/delete`, { params }) };
// 查询续费列表
export const queryrenewrecord = params => { return service.post(`/api/base_monthcard_car/queryrenewrecord`, params) };
// 创建
export const cancellation = params => { return service.post(`/api/order/cancellation`, params) };
// 查询退款信息
export const refundresultquery = params => { return service.get(`/api/order/refundresultquery`, { params }) };
// 导入
export const importd = params => {
    return service.post(`/api/base_monthcard_car/import`, params)
};

export const editrecord = params => { return service.put(`/api/base_monthcard_car/editrecord`, params) };